import { c as _c } from "react/compiler-runtime";
import { ClickAndCollectDeliveryInformation, type ClickAndCollectDeliveryInformationProps } from './click-and-collect-delivery-information';
import { HomeDeliveryInformation, type HomeDeliveryInformationProps } from './home-delivery-information';
import React from 'react';
import selectCountryCode from '@spa/lib/store/settings/selectors/selectCountryCode';
import styles from './product-delivery-information.component.module.scss';
import { useSelector } from 'react-redux';
export type ProductDeliveryInformationProps = HomeDeliveryInformationProps & ClickAndCollectDeliveryInformationProps;
export const ProductDeliveryInformation = properties => {
  const $ = _c(16);
  const {
    homeDeliveryDeliveryMode,
    isHomeDeliveryAllowed,
    isClickAndCollectAllowed,
    isPreOrderEnabled,
    preOrderSettings,
    releaseDate,
    selectedStore,
    setSelectedProduct,
    setShowStoreFinderPopup
  } = properties;
  const countryCode = useSelector(selectCountryCode);
  const isSwitzerland = countryCode === "CH";
  let t0;
  if ($[0] !== homeDeliveryDeliveryMode || $[1] !== isHomeDeliveryAllowed || $[2] !== isPreOrderEnabled || $[3] !== isSwitzerland || $[4] !== preOrderSettings || $[5] !== releaseDate) {
    t0 = !isSwitzerland && <HomeDeliveryInformation homeDeliveryDeliveryMode={homeDeliveryDeliveryMode} isHomeDeliveryAllowed={isHomeDeliveryAllowed} isPreOrderEnabled={isPreOrderEnabled} preOrderSettings={preOrderSettings} releaseDate={releaseDate} />;
    $[0] = homeDeliveryDeliveryMode;
    $[1] = isHomeDeliveryAllowed;
    $[2] = isPreOrderEnabled;
    $[3] = isSwitzerland;
    $[4] = preOrderSettings;
    $[5] = releaseDate;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== isClickAndCollectAllowed || $[8] !== releaseDate || $[9] !== selectedStore || $[10] !== setSelectedProduct || $[11] !== setShowStoreFinderPopup) {
    t1 = <ClickAndCollectDeliveryInformation isClickAndCollectAllowed={isClickAndCollectAllowed} selectedStore={selectedStore} setSelectedProduct={setSelectedProduct} setShowStoreFinderPopup={setShowStoreFinderPopup} releaseDate={releaseDate} />;
    $[7] = isClickAndCollectAllowed;
    $[8] = releaseDate;
    $[9] = selectedStore;
    $[10] = setSelectedProduct;
    $[11] = setShowStoreFinderPopup;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== t0 || $[14] !== t1) {
    t2 = <div className={styles["delivery-information"]}>{t0}{t1}</div>;
    $[13] = t0;
    $[14] = t1;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
};